import { render, staticRenderFns } from "./TemplateSaved.vue?vue&type=template&id=018c46b6"
import script from "./TemplateSaved.vue?vue&type=script&lang=js"
export * from "./TemplateSaved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports